<template>
    <div class="relative">
        <AxiosOverlayer :loading="axiosCall" :position-class="'absolute'"/>
        <div class="container mx-auto px-2 py-4">
            <h2>Changelogs</h2>
            <ul v-if="changelogs.items.length">
                <template v-for="(changelog, index) in changelogs.items">
                    <li class="py-4 px-4 border-r border-l border-t border-b mb-4" :class="[index > 0 || (index + 1) == changelogs.items.length ? '': '']">
                        <div class="bg-gray-200 p-4 -mx-4 -mt-4 mb-4">
                            <span class="text-black font-bold lining-nums tabular-nums">v{{ changelog.version }}</span> <span class="lining-nums tabular-nums">({{ this.$moment(String(changelog.date)).format('DD.MM.YYYY')  }})</span> - {{ changelog.title }}
                        </div>
                        <div v-html="changelog.description"/>
                    </li>
                </template>
            </ul>
            <div v-else>
                Keine Changelogs ersgtellt
            </div>
        </div>
    </div>
</template>

<script>

import { getCurrentInstance, onMounted, ref, reactive} from 'vue';
import {API} from "@/utils/api";

export default {
    setup() {
        const changelogs = reactive({items: []});

        const internalInstance = getCurrentInstance();
        const moment = internalInstance.appContext.config.globalProperties.$moment;
        const emitter = internalInstance.appContext.config.globalProperties.$emitter;
        const axiosCall = ref(false);

        onMounted(() => {

            API.get('getChangelogs').then((resp) => {
                axiosCall.value = false;
                changelogs.items = resp.data.changelogs;

            }).catch(err => {
                axiosCall.value = false
                console.error(err);

                emitter.emit("flash-message", {
                    text: err.response.data.message,
                    type: 'error'
                })
            })
        })

        return {
            axiosCall,
            changelogs
        }
    }
}
</script>
